export const adresgegevensWijzigenNl = {
  AdresGegevensWijzigenFormulierStapGegevensWijzigen: "Gegevens wijzigen",
  MijnPostadresWijzigen: "Mijn postadres wijzigen",
  MijnWoonadresEnPostadresWijzigen: "Mijn woonadres en postadres wijzigen",
  MijnWoonadresWijzigen: "Mijn woonadres wijzigen"
};
